import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/Service/auth.service';
import { FamilyInviationService } from 'src/app/Service/familyinviation.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';
import { QuestionnaireService } from '../questionnaires/questionnaires.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-accept-fc-invite',
    templateUrl: './accept-fc-invite.component.html',
    styleUrls: [
        './../accept/accept.component.css',
        './../questionnaires/questionnaires.component.css',
        './accept-fc-invite.component.css',
    ],
    standalone: false
})
export class AcceptFcInviteComponent implements OnInit {
  @ViewChild('AcceptInvite') AcceptInvite: any;
  isCollapsed = true;
  isNewUser: boolean;
  id: string;
  isBtnDisable = true;
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public familyInviationService: FamilyInviationService,
    public notify: NotificationService,
    public qService: QuestionnaireService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    if (this.userService.isLoggedin) {
      this.router.navigateByUrl('/user');
    } else {
      this.activatedRoute.params.subscribe((params) => {
        this.id = params['id'];
        if (this.id) {
          this.familyInviationService
            .getFCInvitationDetails(this.id)
            .pipe(switchMap(() => this.verifyEmail()))
            .subscribe({
              next: ({ isNewUser }) => {
                this.isNewUser = isNewUser;
                this.loader.HideLoading();
                this.isBtnDisable = false;
              },
              error: (error) => {
                console.error(error);
                this.loader.HideLoading();
              },
            });
        } else {
          this.router.navigateByUrl('');
        }
      });
    }
  }

  verifyEmail() {
    const receiptEmail =
      this.familyInviationService.FcInvitationDetails?.receiptEmail;

    if (!receiptEmail) {
      console.error('Receipt email is missing');
      return of({ isNewUser: false });
    }

    return this.qService.getInteractionId().pipe(
      switchMap((interactionId) =>
        forkJoin({
          interactionId: of(interactionId),
          existsEmail: this.qService.IsExistsEmail(interactionId, receiptEmail),
        })
      ),
      switchMap(({ interactionId, existsEmail }) => {
        return of({ isNewUser: existsEmail.data.newUser });
      })
    );
  }
  AccceptInvitePopup(): void {
    this.modalService.open(this.AcceptInvite, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'md',
    });
  }
  acceptInvite() {
    this.familyInviationService.AcceptFCInvitation(this.id);
    this.router.navigate(['/login']);
  }

  navigateToQuestionnaires() {
    this.router.navigate(['/questionnaires']);
  }
  onClose(): void {
    this.modalService.dismissAll();
    this.acceptInvite();

  }
}
